import api from '@/api'
import qs from 'qs'


/* 获取协会列表 */
export function getOrgList () {
  return api({
    url: '/user/organList',
    method: 'GET',
  })
}

/* 校验信息征集资格 */
export function checkOrg (params={}) {
  const { organName, code } = params
  return api({
    url: `/user/organCheck/${organName}/${code}`,
    method: 'GET'
  })
}

/* 校验协会推荐教练员 会员校验 */
export function checkOrgForCoach (params = {}) {
  const { organName, code } = params
  return api({
    url: `/index/organRecommendCheck/${organName}/${code}`,
    method: 'GET'
  })
}

/* 校验协会推荐球员 会员校验 */
export function organPlayerRecommendCheck (params = {}) {
  const { organName, code } = params
  return api({
    url: `/index/organPlayerRecommendCheck/${organName}/${code}`,
    method: 'GET'
  })
}

/* 校验协会推荐球员 会员校验 */
export function organMatchCheck (params = {}) {
  const { organName, code } = params
  return api({
    url: `/index/organMatchCheck/${organName}/${code}`,
    method: 'GET'
  })
}

/* 提交青少年球队信息征集信息 */
export function postTeanTeamInfo (data = {}) {
  return api ({
    url: '/user/informationSubmit',
    method: 'POST',
    data
  })
}

/* 教练员招聘  进一步考察  提交 */
export function postCoach (data={}) {
  return api({
    url: '/user/coachInspectionSubmit',
    method: 'POST',
    data
  })
}

/* 会员协会提交推荐教练员 */
export function postCocachRecommend (data) {
  return api({
    url: '/index/recommendSubmit',
    method: 'POST',
    data
  })
}

/* 会员协会提交推荐教练员 */
export function postPlayerRecommend (data) {
  return api({
    url: '/index/recommendPlayerSubmit',
    method: 'POST',
    data
  })
}

/* 会员协会提交推荐教练员 */
export function postYouthMatch (data) {
  return api({
    url: '/index/youthMatchSubmit',
    method: 'POST',
    data
  })
}

/* 会员协会提交推荐教练员 */
export function recommendMajorDomoSubmit (data) {
  return api({
    url: '/index/recommendMajorDomoSubmit',
    method: 'POST',
    data
  })
}

/* 校验协会推荐球员 会员校验 */
export function organMajorDomoRecommendCheck (params = {}) {
  const { organName, code } = params
  return api({
    url: `/index/organMajorDomoRecommendCheck/${organName}/${code}`,
    method: 'GET'
  })
}

/* 会员协会提交急救培训班 */
export function recommendEmergencySubmit (data) {
  return api({
    url: '/index/recommendEmergencySubmit',
    method: 'POST',
    data
  })
}

/* 校验协会推荐球员 会员校验 */
export function organEmergencyRecommendCheck (params = {}) {
  const { organName, code } = params
  return api({
    url: `/index/organEmergencyRecommendCheck/${organName}/${code}`,
    method: 'GET'
  })
}

/* 线上青训大纲分享会报名 会员校验 */
export function organLineOutlineRecommendCheck (params = {}) {
  const { organName, code } = params
  return api({
    url: `/index/organLineOutlineRecommendCheck/${organName}/${code}`,
    method: 'GET'
  })
}

/* 线上青训大纲分享会报名提交 */
export function recommendLineOutlineSubmit (data) {
  return api({
    url: '/index/recommendLineOutlineSubmit',
    method: 'POST',
    data
  })
}

/* 
青训总监研讨会信息提交 */
export function uploadSeminarInfo(data) {
  return api({
    url: '/index/recommendCoachDomoSubmit',
    method: 'POST',
    data
  })
}

/* 青训总监研讨会 */
export function checkCodeForSeminarInfo(params) {
  const { organ_name, code } = params;
  return api({
    url: `/index/recommendCoachDomoCheck/${organ_name}/${code}`,
    method: 'GET',
  })
}